import { api } from "../api";
import {
  CreateDemoSchoolInput,
  CreateDemoSchoolResult,
  DemoSchoolListItem,
  ProvisionDemoUserInput,
  ProvisionDemoUserResult,
} from "./demo.types";

export const createDemoSchool = (
  input: CreateDemoSchoolInput
): Promise<CreateDemoSchoolResult> =>
  api
    .post<CreateDemoSchoolResult>("/demo-data/schools", input)
    .then((r) => r.data);

export const listDemoSchools = (): Promise<DemoSchoolListItem[]> =>
  api.get<DemoSchoolListItem[]>("/demo-data/schools").then((r) => r.data);

export const deleteDemoSchool = (id: number): Promise<void> =>
  api.delete(`/demo-data/schools/${id}`).then(() => undefined);

export const provisionDemoUser = (
  input: ProvisionDemoUserInput
): Promise<ProvisionDemoUserResult> =>
  api
    .post<ProvisionDemoUserResult>("/demo-data/provision", input)
    .then((r) => r.data);
